import type { Template } from "../../components/TemplateCreationModal";
import type { ApiTemplate } from "../../hooks/useTemplates";
import { premadeTemplatesAsDashboardTemplates } from "../../constants/premadeNoticeTemplates";

/** The Organization's own Templates, as Create notice shows them. */
export const mapApiTemplates = (templates: ApiTemplate[]): Template[] =>
  templates.map((t) => ({
    id: t.templateId,
    templateId: t.templateId,
    name: t.name,
    title: t.title,
    description: t.description,
    background: t.background,
    noticeType: t.noticeType === "custom_event" ? "custom_event" : "info",
    isUrgent: t.isUrgent,
    audience: t.audience,
    targetSubcircle: t.targetSubcircle,
    createdAt: t.createdAt,
    usageCount: t.usageCount,
    organizationId: t.organizationId,
  }));

/** Every Template on Create notice: the premade ones first, then the Organization's own. */
export const createPageTemplates = (
  templates: Template[],
  schoolName: string | undefined,
): Template[] => [
  ...premadeTemplatesAsDashboardTemplates(schoolName?.trim() || "your school"),
  ...templates,
];
